import {
  Plus,
  Settings,
  Phone,
  AlertTriangle,
  X,
  Package,
  Send,
  Truck,
  CheckCircle,
  RotateCcw,
  Trash2,
  HelpCircle,
} from "lucide-react";
import { Order } from "../types";

export interface StatusInfo {
  name: string;
  color: string;
  icon: React.ComponentType<{ className?: string }>;
  value: number;
}

export const STATUS_MAP: { [key: number]: StatusInfo } = {
  1: { name: "New", color: "bg-blue-100 text-blue-800", icon: Plus, value: 1 },
  2: { name: "Processing", color: "bg-yellow-100 text-yellow-800", icon: Settings, value: 2 },
  3: { name: "Call back", color: "bg-orange-100 text-orange-800", icon: Phone, value: 3 },
  4: { name: "Hold", color: "bg-yellow-100 text-yellow-800", icon: AlertTriangle, value: 4 },
  5: { name: "Cancel", color: "bg-red-100 text-red-800", icon: X, value: 5 },
  6: { name: "Packing", color: "bg-purple-100 text-purple-800", icon: Package, value: 6 },
  7: { name: "Sending", color: "bg-indigo-100 text-indigo-800", icon: Send, value: 7 },
  8: { name: "Delivery", color: "bg-blue-100 text-blue-800", icon: Truck, value: 8 },
  9: { name: "Delivered", color: "bg-green-100 text-green-800", icon: CheckCircle, value: 9 },
  10: { name: "Complete", color: "bg-green-100 text-green-800", icon: CheckCircle, value: 10 },
  11: { name: "Return", color: "bg-orange-100 text-orange-800", icon: RotateCcw, value: 11 },
  12: { name: "Deleted", color: "bg-gray-100 text-gray-800", icon: Trash2, value: 12 },
};

// Cancellation reasons matching AlterCPA (1-17)
export const CANCEL_REASONS: { [key: number]: string } = {
  1: "Incorrect phone",
  2: "Changed his mind",
  3: "Did not order",
  4: "Requires certificate",
  5: "Wrong GEO",
  6: "Trash or test",
  7: "Duplication order",
  8: "Ordered elsewhere",
  9: "Expensive",
  10: "Not satisfied with delivery",
  11: "Could not get through",
  12: "Possibly fraud",
  13: "Speaks different language",
  14: "Product did not fit",
  15: "Offer disabled",
  16: "Consultation",
  17: "Cancelled by timer",
};

/**
 * Get status info by status code
 */
export const getStatusInfo = (status: number): StatusInfo => {
  return (
    STATUS_MAP[status] || {
      name: "Unknown",
      color: "bg-gray-100 text-gray-800",
      icon: HelpCircle,
      value: status,
    }
  );
};

/**
 * Get status display name with cancellation reason and stage for cancelled orders
 */
export const getStatusDisplayName = (order: Order | null, status?: number): string => {
  const statusCode = status !== undefined ? status : order?.status;
  if (statusCode === undefined) return "Unknown";

  const statusInfo = getStatusInfo(statusCode);
  
  // If status is Cancel (5), add reason and stage info
  if (statusCode === 5 && order) {
    const reasonCode = (order as any).cancelReason || order.reason;
    const reasonName = reasonCode ? CANCEL_REASONS[Number(reasonCode)] : null;
    const stage = order.stage;

    let statusText = statusInfo.name;
    if (reasonName) {
      statusText += ` - ${reasonName}`;
    }
    if (stage) {
      statusText += ` (Stage ${stage})`;
    }
    return statusText;
  }

  return statusInfo.name;
};

